import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import appRoutes from "../utils/routes"
import { useAppState } from './hooks'

export const useEmailRedirect = () => {
    const history = useHistory()
    const { userProfile, userEmailVerified, userEmailPreverified } = useAppState()

    const redirect = useCallback(async () => {
        // Surface the BE inconsistency that produced PORTAL-20-7V/7T: a userProfile
        // arriving without `country`. We can't decide forceEmailValidate without it,
        // so log and fall through (no redirect) — the broader auth-redirect orchestrator
        // re-runs on each profile update and will gate correctly once country resolves.
        if (userProfile && !userProfile.country) {
            Sentry.captureMessage('useEmailRedirect: userProfile.country missing', 'warning')
        }

        if (
            !userEmailPreverified &&
            (!userEmailVerified && userProfile?.country?.forceEmailValidate)
        ) {
            history.push(appRoutes.account.validateEmail)
            return false
        }

        return true
    }, [history, userEmailPreverified, userEmailVerified, userProfile])

    return redirect
}